import React, { useState, useContext } from "react";
import { NextUIProvider, Container, Card, Grid, Link, Row, Col} from '@nextui-org/react';
import {CardScheme} from "../card/card";
import "./current-weather.css";
import axios from "axios";
import {BASE_URL, KEY } from "../../constants";
import { Input, Button, Loading, Spacer } from '@nextui-org/react';
//import { IconlyProvider, Home, Notification, Iconly} from 'react-iconly';
import { MdSearch, MdRoom } from "react-icons/md";
import WeatherInfo from "../weather-info/weather-info";
import Forecast from "../forecast/forecast";

export default function CurrentWeather({defaultCity}) {
  const [city, setCity] = useState(defaultCity);
  const [weatherData, setWeatherData] = useState({ready: false});

  const showCityWeather = (response) => {
    console.log(response.data)
    const {
      name,
      weather: [{
          main: weatherTitle,
          description: weatherDescription,
          icon: iconId
      }],
      main: {
          temp: temperature,
          humidity
      },
      wind: {
          speed: windSpeed
      },
      coord: coordinates,
      dt: time,
    } = response.data;

    if(response.statusText !== 'OK') {
      alert('Error', response.statusText)
    }
  

    setWeatherData({
      ready: true,
      weatherTitle,
      weatherDescription,
      iconId,
      temperature,
      humidity,
      windSpeed,
      coordinates,
      time,
      name
    });
  };


  const handleCityChange = (event) => {
    setCity(event.target.value);
  };

  const search = () => {
    const apiUrl = `${BASE_URL}/weather?q=${city}&appid=${KEY}&units=metric`;
    axios.get(apiUrl).then(showCityWeather);
  };  

  const handleSubmit = (event) => {
    event.preventDefault();
    search();
  };


  if(weatherData.ready) {
    return (
    <>
      <form id="search-form" onSubmit={handleSubmit}>
      <Container>
        <Row>
          <Input 
            placeholder="Enter a city..." 
            type="search"
            name="search" 
            id="search-field"
            size="lg"
            width="100%"
            rounded
            onChange={handleCityChange}
            required
          />
          <Spacer x={0.5}/>
          <Button 
            id="search-btn"
            type="submit"
            auto 
            color="secondary" 
            size="lg"
            rounded 
            bordered>
            <MdSearch size="1.2rem"/>
          </Button>
          <Spacer x={0.5}/>
          <Button 
            id="localisation-btn"
            type="button"
            auto 
            color="secondary" 
            rounded 
            size="lg"
            bordered>
            <MdRoom size="1.2rem"/>
          </Button>
        </Row>
      </Container>
      </form>
      <Container>
        <Row>
          <Col>
            <WeatherInfo data={weatherData}/>
          </Col>
        </Row>
      </Container>
      
      <Grid xs={12} md={12}lg={12}> 
        <Forecast coordinates={weatherData.coordinates}/>
      </Grid>
      
    </>
  );
  } else {
    search();
    return (<h1>Loading</h1>)
  }
}





{/* <div class="card__content-current">
      <h3 class="heading current">{currentWeather.city}</h3>
      <img id="icon" class="emoji" alt="" href={currentWeather.imgUrl} />
      <p class="status">{currentWeather.description}</p>
      <div class="temperature">
        <strong id="temperature">{currentWeather.temperature}</strong>
        <a id="celsius" class="temperature__link celsius active" href="#">
          ℃
        </a>
        <a id="fahrenheit" class="temperature__link fahrenheit" href="#">
          ℉
        </a>
      </div>
      <div class="weather-details">
        <p class="weather__description">{currentWeather.description}</p>
        <p class="weather__wind">wind: {currentWeather.wind}</p>
        <p id="humidity">humidity: {currentWeather.humidity}</p>
      </div>
    </div> */}